import React, { useEffect, useState } from 'react'
import SRDetailComponent from '../SRDetailComponent';

const MSubRoutesComponent = ({
    contentType,
    pagesContent,
}: any) => {
    return (
        <div>
            {contentType == "pages" && <>Pages</>}
            {contentType == "pdetails" && <SRDetailComponent />}
        </div>
    )
}

export default MSubRoutesComponent